// A customer needs a complete profile before contacting a partner (backend checks the same).

const RETURN_KEY = "returnAfterProfile";

export const missingProfileFields = (user = {}) =>
    [
        [!String(user.firstName || "").trim(), "first name"],
        [!String(user.lastName || "").trim(), "last name"],
        [!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(user.email || "").trim()), "email"],
        [!user.gender, "gender"],
    ]
        .filter(([missing]) => missing)
        .map(([, label]) => label);

export const isProfileComplete = (user) => missingProfileFields(user).length === 0;

// Remember where to send the customer once they finish their profile
export const setReturnAfterProfile = (path) => localStorage.setItem(RETURN_KEY, path);
export const takeReturnAfterProfile = () => {
    const path = localStorage.getItem(RETURN_KEY);
    localStorage.removeItem(RETURN_KEY);
    return path;
};
export const hasReturnAfterProfile = () => !!localStorage.getItem(RETURN_KEY);
